module.exports = __webpack_public_path__ + "static/img/dropoff-banner.3721d72c.jpeg";